import React from 'react';
import "./CSVToFieldSelectionContainer.scss";
import { IconButton, Select } from '@livingdesign/react';
import { TrashCan } from '@livingdesign/icons';
import { useCampaignContext } from '../../../../../../../contexts/Campaign';
import { cs } from 'date-fns/locale';
import { DATA_SOURCE_TYPES, RECIPIENTS } from '../../../../../../../consts/DBFields';
import { useMessageDetailsForm } from '../../../../../../../contexts/MessageDetailsForm';
import { getCsvFilename, getRecipientFields } from '../../../../../../../utils/campaignEdit';
import { isStandardCampaign } from '../../../../../../../utils/campaignEdit';

export const QA_ID_PREFIX = "CSVToFieldSelectionContainer";

function CSVToFieldSelectionContainer() {
    
    const {
        // dataSourceHeadingsV2,
        // notificationRecipientsFieldsV2,
        notificationRecipientsFields,
        dataSourceHeadings,
        savingCampaign,
    } = useCampaignContext();

    const {
        formValues,
        selectedCampaign,
        notificationIndex,
        channel,
    } = useMessageDetailsForm();

    const getSelectedRecipientField = (recipientType) => {
        return getRecipientFields(selectedCampaign, notificationIndex, recipientType);
    }

    return (
        <section className='csv-to-field-selection-container' data-testid={`${QA_ID_PREFIX}-container`}>
            {formValues?.csvFiles?.map((csvFile, index) => {
                return (
                    <div className='csv-to-field-selection-item' key={csvFile.name} data-testid={`${QA_ID_PREFIX}-csv-item-${index}`}>
                        <div className='csv-to-field-selection-item-header' data-testid={`${QA_ID_PREFIX}-csv-item-header-${index}`}>
                            <h3 data-testid={`${QA_ID_PREFIX}-csv-filename-${index}`}>{getCsvFilename(csvFile)}</h3>
                            <IconButton disabled={savingCampaign} a11yLabel='delete-csv-file-button' data-testid={`${QA_ID_PREFIX}-delete-csv-button-${index}`}>
                                <TrashCan />
                            </IconButton>
                        </div>
                        <div className='typo-1' data-testid={`${QA_ID_PREFIX}-required-field-label-${index}`}>*Required field</div>
                        <div className='select-input-container' data-testid={`${QA_ID_PREFIX}-to-select-container-${index}`}>
                            <Select
                                label="To*"
                                value={getSelectedRecipientField(RECIPIENTS.TO)}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if(value === "null") return;
                                    notificationRecipientsFields[RECIPIENTS.TO].handleChange(value);
                                }}
                                disabled={savingCampaign}
                                data-testid={`${QA_ID_PREFIX}-to-select-${index}`}
                            >
                                <option value={"null"} data-testid={`${QA_ID_PREFIX}-to-default-option-${index}`}>Select a column header</option>
                                {dataSourceHeadings.map((headerField, _index) => {
                                    return (
                                        <option key={_index} value={headerField.value} data-testid={`${QA_ID_PREFIX}-${index}-to-option-${_index}`}>{headerField.label}</option>
                                    )
                                })}
                            </Select>
                        </div>
                        {(channel === 'mail') && !isStandardCampaign(selectedCampaign, notificationIndex) && 
                            <div className='select-input-container' data-testid={`${QA_ID_PREFIX}-cc-select-container-${index}`}>
                                <Select
                                    label="Cc"
                                    value={getSelectedRecipientField(RECIPIENTS.CC)}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if(value === "null") return;
                                        notificationRecipientsFields[RECIPIENTS.CC].handleChange(value);
                                    }}
                                    disabled={savingCampaign}
                                    data-testid={`${QA_ID_PREFIX}-cc-select-${index}`}
                                >
                                    <option value={"null"} data-testid={`${QA_ID_PREFIX}-cc-default-option-${index}`}>Select a column header</option>
                                    {dataSourceHeadings.map((headerField, _index) => {
                                        return (
                                            <option key={_index} value={headerField.value} data-testid={`${QA_ID_PREFIX}-${index}-cc-option-${_index}`}>{headerField.label}</option>
                                        )
                                    })}
                                </Select>
                            </div>
                        }
                        {(channel === 'mail') && !isStandardCampaign(selectedCampaign, notificationIndex) &&
                            <div className='select-input-container' data-testid={`${QA_ID_PREFIX}-bcc-select-container-${index}`}>
                                <Select
                                    label="Bcc"
                                    value={getSelectedRecipientField(RECIPIENTS.BCC)}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if(value === "null") return;
                                        notificationRecipientsFields[RECIPIENTS.BCC].handleChange(value);
                                    }}
                                    disabled={savingCampaign}
                                    data-testid={`${QA_ID_PREFIX}-bcc-select-${index}`}
                                >
                                    <option value={"null"} data-testid={`${QA_ID_PREFIX}-bcc-default-option-${index}`}>Select a column header</option>
                                    {dataSourceHeadings.map((headerField, _index) => {
                                        return (
                                            <option key={_index} value={headerField.value} data-testid={`${QA_ID_PREFIX}-${index}-bcc-option-${_index}`}>{headerField.label}</option>
                                        )
                                    })}
                                </Select>
                            </div>
                        }
                    </div>
                )
            })}
        </section>
    )
}

export default CSVToFieldSelectionContainer;